// 主題配置系統
export const THEMES = {
  light: {
    id: "light",
    name: "light",
    colors: {
      primary: "#3b82f6",
      secondary: "#6b7280",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      background: "#ffffff",
      surface: "#f8fafc",
      text: "#111827",
      textSecondary: "#6b7280",
      border: "#d1d5db",
      highlight: "#fef3c7"
    },
    classes: {
      background: "bg-gradient-to-br from-white to-gray-50",
      text: "text-gray-900",
      textSecondary: "text-gray-600",
      button: "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-gray-500 to-slate-600 hover:from-gray-600 hover:to-slate-700 text-white shadow-md",
      buttonDanger: "bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg",
      buttonWarning: "bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white shadow-lg",
      buttonInfo: "bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-gray-300 to-gray-400 text-gray-500 cursor-not-allowed shadow-none",
      grid: "bg-gradient-to-br from-gray-50 to-slate-100 border border-gray-200 shadow-inner",
      surface: "bg-gradient-to-br from-white to-gray-50 shadow-sm",
      border: "border-gray-300",
      highlight: "ring-red-400",
      input: "border-gray-300 bg-gradient-to-r from-white to-gray-50 text-gray-900 shadow-inner",
      select: "border-gray-300 bg-white text-gray-900 shadow-inner [&>option]:bg-white [&>option]:text-gray-900",
      card: "bg-gradient-to-br from-white to-gray-50 border-gray-200 shadow-lg"
    }
  },
  dark: {
    id: "dark",
    name: "dark",
    colors: {
      primary: "#3b82f6",
      secondary: "#6b7280",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      background: "#111827",
      surface: "#1f2937",
      text: "#f9fafb",
      textSecondary: "#9ca3af",
      border: "#374151",
      highlight: "#fbbf24"
    },
    classes: {
      background: "bg-gradient-to-br from-gray-900 to-slate-800",
      text: "text-gray-100",
      textSecondary: "text-gray-400",
      button: "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-gray-600 to-slate-600 hover:from-gray-700 hover:to-slate-700 text-white shadow-md",
      buttonDanger: "bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg",
      buttonWarning: "bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white shadow-lg",
      buttonInfo: "bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-gray-600 to-slate-600 text-gray-500 cursor-not-allowed shadow-none",
      grid: "bg-gradient-to-br from-gray-800 to-slate-700 border border-gray-600 shadow-inner",
      surface: "bg-gradient-to-br from-gray-800 to-slate-800 shadow-md",
      border: "border-gray-700",
      highlight: "ring-yellow-400",
      input: "border-gray-600 bg-gradient-to-r from-gray-800 to-slate-800 text-gray-100 shadow-inner",
      select: "border-gray-600 bg-gray-800 text-gray-100 shadow-inner [&>option]:bg-gray-800 [&>option]:text-gray-100",
      card: "bg-gradient-to-br from-gray-800 to-slate-800 border-gray-700 shadow-xl"
    }
  },
  blue: {
    id: "blue",
    name: "blue",
    colors: {
      primary: "#1e40af",
      secondary: "#64748b",
      success: "#059669",
      warning: "#d97706",
      error: "#dc2626",
      background: "#dbeafe",
      surface: "#eff6ff",
      text: "#1e3a8a",
      textSecondary: "#475569",
      border: "#93c5fd",
      highlight: "#fef3c7"
    },
    classes: {
      background: "bg-gradient-to-br from-blue-50 to-cyan-100",
      text: "text-blue-900",
      textSecondary: "text-blue-700",
      button: "bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-md",
      buttonDanger: "bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 text-white shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 text-white shadow-lg",
      buttonWarning: "bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white shadow-lg",
      buttonInfo: "bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-blue-300 to-cyan-300 text-blue-500 cursor-not-allowed shadow-none",
      grid: "bg-gradient-to-br from-blue-100 to-cyan-200 border border-blue-300 shadow-inner",
      surface: "bg-gradient-to-br from-blue-50 to-cyan-100 shadow-sm",
      border: "border-blue-300",
      highlight: "ring-red-400",
      input: "border-blue-300 bg-gradient-to-r from-white to-blue-50 text-blue-900 shadow-inner",
      select: "border-blue-300 bg-white text-blue-900 shadow-inner [&>option]:bg-white [&>option]:text-blue-900",
      card: "bg-gradient-to-br from-white to-blue-50 border-blue-200 shadow-lg"
    }
  },
  lavender: {
    id: "lavender",
    name: "lavender",
    colors: {
      primary: "#8b5cf6",
      secondary: "#a78bfa",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      background: "#faf5ff",
      surface: "#f3e8ff",
      text: "#581c87",
      textSecondary: "#7c3aed",
      border: "#c4b5fd",
      highlight: "#fbbf24"
    },
    classes: {
      background: "bg-gradient-to-br from-violet-50 to-purple-100",
      text: "text-violet-900",
      textSecondary: "text-violet-700",
      button: "bg-gradient-to-r from-violet-500 to-purple-500 hover:from-violet-600 hover:to-purple-600 text-white shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-purple-400 to-violet-400 hover:from-purple-500 hover:to-violet-500 text-white",
      buttonDanger: "bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 text-white shadow-lg",
      buttonWarning: "bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-white shadow-lg",
      buttonInfo: "bg-gradient-to-r from-indigo-500 to-blue-500 hover:from-indigo-600 hover:to-blue-600 text-white shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-violet-300 to-purple-300 text-violet-600 shadow-none cursor-not-allowed",
      grid: "bg-gradient-to-br from-violet-100 to-purple-200 border border-violet-300",
      surface: "bg-gradient-to-br from-violet-100 to-purple-100",
      border: "border-violet-300",
      highlight: "ring-yellow-400",
      input: "border-violet-300 bg-violet-50 text-violet-900",
      select: "border-violet-300 bg-violet-50 text-violet-900 [&>option]:bg-violet-50 [&>option]:text-violet-900",
      card: "bg-gradient-to-br from-violet-100 to-purple-100 border-violet-200 shadow-lg"
    }
  },
  colorful: {
    id: "colorful",
    name: "colorful",
    colors: {
      primary: "#7c3aed",
      secondary: "#ec4899",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      background: "#fef7ff",
      surface: "#fdf4ff",
      text: "#581c87",
      textSecondary: "#a21caf",
      border: "#c084fc",
      highlight: "#fbbf24"
    },
    classes: {
      background: "bg-gradient-to-br from-purple-50 to-pink-50",
      text: "text-purple-900",
      textSecondary: "text-purple-700",
      button: "bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white",
      buttonSecondary: "bg-gradient-to-r from-orange-400 to-red-400 hover:from-orange-500 hover:to-red-500 text-white",
      buttonDanger: "bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white",
      buttonSuccess: "bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white",
      buttonWarning: "bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white",
      buttonInfo: "bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white",
      buttonDisabled: "bg-gradient-to-r from-gray-400 to-gray-300 text-gray-500 cursor-not-allowed",
      grid: "bg-gradient-to-br from-purple-100 to-pink-100",
      surface: "bg-white",
      border: "border-purple-300",
      highlight: "ring-yellow-400",
      input: "border-purple-300 bg-white text-purple-900",
      select: "border-purple-300 bg-white text-purple-900 [&>option]:bg-white [&>option]:text-purple-900",
      card: "bg-white border-purple-200 shadow-lg"
    }
  },
  retro: {
    id: "retro",
    name: "retro",
    colors: {
      primary: "#ea580c",
      secondary: "#fb923c",
      success: "#059669",
      warning: "#f59e0b",
      error: "#dc2626",
      background: "#fff7ed",
      surface: "#fed7aa",
      text: "#7c2d12",
      textSecondary: "#c2410c",
      border: "#fdba74",
      highlight: "#ef4444"
    },
    classes: {
      background: "bg-gradient-to-br from-orange-50 to-yellow-100",
      text: "text-orange-900",
      textSecondary: "text-orange-700",
      button: "bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white border-2 border-orange-800 shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white border-2 border-orange-700 shadow-lg",
      buttonDanger: "bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white border-2 border-red-800 shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white border-2 border-green-800 shadow-lg",
      buttonWarning: "bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-white border-2 border-yellow-800 shadow-lg",
      buttonInfo: "bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-2 border-blue-800 shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-orange-300 to-yellow-300 text-orange-600 border-2 border-orange-400 cursor-not-allowed shadow-none",
      grid: "bg-gradient-to-br from-orange-100 to-yellow-200 border-2 border-orange-400 shadow-inner",
      surface: "bg-gradient-to-br from-orange-50 to-yellow-100",
      border: "border-orange-400",
      highlight: "ring-red-400",
      input: "border-orange-400 bg-gradient-to-r from-orange-50 to-yellow-50 text-orange-900 shadow-inner",
      select: "border-orange-400 bg-orange-50 text-orange-900 shadow-inner [&>option]:bg-orange-50 [&>option]:text-orange-900",
      card: "bg-gradient-to-br from-orange-50 to-yellow-100 border-orange-300 shadow-lg"
    }
  },
  pinkcrystal: {
    id: "pinkcrystal",
    name: "pinkcrystal",
    colors: {
      primary: "#ec4899",
      secondary: "#f472b6",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      background: "#fdf2f8",
      surface: "#fce7f3",
      text: "#831843",
      textSecondary: "#be185d",
      border: "#f9a8d4",
      highlight: "#fbbf24"
    },
    classes: {
      background: "bg-gradient-to-br from-pink-50 to-rose-100",
      text: "text-pink-900",
      textSecondary: "text-pink-700",
      button: "bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-rose-400 to-pink-400 hover:from-rose-500 hover:to-pink-500 text-white",
      buttonDanger: "bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 text-white shadow-lg",
      buttonWarning: "bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-white shadow-lg",
      buttonInfo: "bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-pink-300 to-rose-300 text-pink-500 shadow-none cursor-not-allowed",
      grid: "bg-gradient-to-br from-pink-100 to-rose-200 border border-pink-300",
      surface: "bg-gradient-to-br from-pink-100 to-rose-100",
      border: "border-pink-300",
      highlight: "ring-yellow-400",
      input: "border-pink-300 bg-pink-50 text-pink-900",
      select: "border-pink-300 bg-pink-50 text-pink-900 [&>option]:bg-pink-50 [&>option]:text-pink-900",
      card: "bg-gradient-to-br from-pink-100 to-rose-100 border-pink-200 shadow-lg"
    }
  },
  yellowduck: {
    id: "yellowduck",
    name: "yellowduck",
    colors: {
      primary: "#eab308",
      secondary: "#facc15",
      success: "#16a34a",
      warning: "#f59e0b",
      error: "#dc2626",
      background: "#fefce8",
      surface: "#fef3c7",
      text: "#713f12",
      textSecondary: "#a16207",
      border: "#fde047",
      highlight: "#f97316"
    },
    classes: {
      background: "bg-gradient-to-br from-yellow-50 to-amber-100",
      text: "text-yellow-900",
      textSecondary: "text-yellow-700",
      button: "bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-white shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-amber-400 to-yellow-400 hover:from-amber-500 hover:to-yellow-500 text-white",
      buttonDanger: "bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 text-white shadow-lg",
      buttonWarning: "bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white shadow-lg",
      buttonInfo: "bg-gradient-to-r from-sky-500 to-cyan-500 hover:from-sky-600 hover:to-cyan-600 text-white shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-yellow-300 to-amber-300 text-yellow-600 shadow-none cursor-not-allowed",
      grid: "bg-gradient-to-br from-yellow-100 to-amber-200 border border-yellow-300",
      surface: "bg-gradient-to-br from-yellow-100 to-amber-100",
      border: "border-yellow-300",
      highlight: "ring-orange-400",
      input: "border-yellow-300 bg-yellow-50 text-yellow-900",
      select: "border-yellow-300 bg-yellow-50 text-yellow-900 [&>option]:bg-yellow-50 [&>option]:text-yellow-900",
      card: "bg-gradient-to-br from-yellow-100 to-amber-100 border-yellow-200 shadow-lg"
    }
  },
  greengrassland: {
    id: "greengrassland",
    name: "greengrassland",
    colors: {
      primary: "#22c55e",
      secondary: "#16a34a",
      success: "#15803d",
      warning: "#eab308",
      error: "#dc2626",
      background: "#f0fdf4",
      surface: "#dcfce7",
      text: "#14532d",
      textSecondary: "#166534",
      border: "#86efac",
      highlight: "#fbbf24"
    },
    classes: {
      background: "bg-gradient-to-br from-green-50 to-emerald-100",
      text: "text-green-900",
      textSecondary: "text-green-700",
      button: "bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white shadow-lg",
      buttonSecondary: "bg-gradient-to-r from-emerald-400 to-green-400 hover:from-emerald-500 hover:to-green-500 text-white",
      buttonDanger: "bg-gradient-to-r from-red-500 to-rose-500 hover:from-red-600 hover:to-rose-600 text-white shadow-lg",
      buttonSuccess: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg",
      buttonWarning: "bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-white shadow-lg",
      buttonInfo: "bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white shadow-lg",
      buttonDisabled: "bg-gradient-to-r from-green-300 to-emerald-300 text-green-600 shadow-none cursor-not-allowed",
      grid: "bg-gradient-to-br from-green-100 to-emerald-200 border border-green-300",
      surface: "bg-gradient-to-br from-green-100 to-emerald-100",
      border: "border-green-300",
      highlight: "ring-yellow-400",
      input: "border-green-300 bg-green-50 text-green-900",
      select: "border-green-300 bg-green-50 text-green-900 [&>option]:bg-green-50 [&>option]:text-green-900",
      card: "bg-gradient-to-br from-green-100 to-emerald-100 border-green-200 shadow-lg"
    }
  },
  silver: {
    id: "silver",
    name: "silver",
    colors: {
      primary: "#374151",
      secondary: "#6b7280",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      background: "#f8fafc",
      surface: "#f1f5f9",
      text: "#0f172a",
      textSecondary: "#475569",
      border: "#cbd5e1",
      highlight: "#fbbf24"
    },
    classes: {
      background: "bg-gradient-to-br from-slate-100 to-gray-200",
      text: "text-slate-900",
      textSecondary: "text-slate-700",
      button: "bg-gradient-to-r from-slate-600 to-gray-600 hover:from-slate-700 hover:to-gray-700 text-white shadow-lg border border-slate-500",
      buttonSecondary: "bg-gradient-to-r from-gray-500 to-slate-500 hover:from-gray-600 hover:to-slate-600 text-white border border-gray-400",
      buttonDanger: "bg-gradient-to-r from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 text-white shadow-lg border border-red-500",
      buttonSuccess: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg border border-green-500",
      buttonWarning: "bg-gradient-to-r from-yellow-600 to-orange-600 hover:from-yellow-700 hover:to-orange-700 text-white shadow-lg border border-yellow-500",
      buttonInfo: "bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white shadow-lg border border-cyan-500",
      buttonDisabled: "bg-gradient-to-r from-slate-400 to-gray-400 text-slate-300 shadow-none border border-slate-300 cursor-not-allowed",
      grid: "bg-gradient-to-br from-slate-200 to-gray-300 border border-slate-400 shadow-inner",
      surface: "bg-gradient-to-br from-slate-200 to-gray-200",
      border: "border-slate-400",
      highlight: "ring-yellow-400",
      input: "border-slate-400 bg-slate-100 text-slate-900 shadow-inner",
      select: "border-slate-400 bg-slate-100 text-slate-900 shadow-inner [&>option]:bg-slate-100 [&>option]:text-slate-900",
      card: "bg-gradient-to-br from-slate-200 to-gray-200 border-slate-300 shadow-lg"
    }
  }
};

// 響應式設計配置
export const RESPONSIVE_CONFIG = {
  // 電腦版配置
  desktop: {
    breakpoint: "lg:", // Tailwind 大屏幕
    layout: {
      containerMaxWidth: "max-w-6xl",
      gridColumns: "grid-cols-8",
      gridGap: "gap-4",
      padding: "p-6",
      margin: "mx-auto",
      headerHeight: "h-16",
      sidebarWidth: "w-64"
    },
    components: {
      drumGrid: {
        cellSize: "w-8 h-8",
        fontSize: "text-sm",
        spacing: "space-x-2 space-y-2"
      },
      controls: {
        buttonSize: "px-6 py-3",
        fontSize: "text-base",
        spacing: "space-x-4"
      },
      editor: {
        columnsPerRow: 7,
        instrumentLabelWidth: "w-12",
        stepNumberHeight: "h-6"
      }
    }
  },
  
  // 手機版配置
  mobile: {
    breakpoint: "sm:", // Tailwind 小屏幕
    layout: {
      containerMaxWidth: "max-w-full",
      gridColumns: "grid-cols-4",
      gridGap: "gap-2",
      padding: "p-3",
      margin: "mx-2",
      headerHeight: "h-14",
      sidebarWidth: "w-full"
    },
    components: {
      drumGrid: {
        cellSize: "w-6 h-6",
        fontSize: "text-xs",
        spacing: "space-x-1 space-y-1"
      },
      controls: {
        buttonSize: "px-3 py-2",
        fontSize: "text-sm",
        spacing: "space-x-2"
      },
      editor: {
        columnsPerRow: 4,
        instrumentLabelWidth: "w-8",
        stepNumberHeight: "h-5"
      }
    }
  },
  
  // 平板配置
  tablet: {
    breakpoint: "md:", // Tailwind 中等屏幕
    layout: {
      containerMaxWidth: "max-w-4xl",
      gridColumns: "grid-cols-6",
      gridGap: "gap-3",
      padding: "p-4",
      margin: "mx-auto",
      headerHeight: "h-15",
      sidebarWidth: "w-48"
    },
    components: {
      drumGrid: {
        cellSize: "w-7 h-7",
        fontSize: "text-sm",
        spacing: "space-x-1.5 space-y-1.5"
      },
      controls: {
        buttonSize: "px-4 py-2.5",
        fontSize: "text-sm",
        spacing: "space-x-3"
      },
      editor: {
        columnsPerRow: 6,
        instrumentLabelWidth: "w-10",
        stepNumberHeight: "h-5"
      }
    }
  }
};

// 支援的主題
export const SUPPORTED_THEMES = [
  { 
    id: 'light', 
    name: 'light',
    nativeName: 'Light Mode',
    icon: '☀️',
    description: 'Clean and bright interface'
  },
  { 
    id: 'dark', 
    name: 'dark',
    nativeName: 'Dark Mode',
    icon: '🌙',
    description: 'Easy on the eyes'
  },
  { 
    id: 'blue', 
    name: 'blue',
    nativeName: 'Ocean Blue',
    icon: '🌊',
    description: 'Calm blue tones'
  },
  { 
    id: 'lavender', 
    name: 'lavender',
    nativeName: 'Lavender Dream',
    icon: '💜',
    description: 'Elegant lavender theme'
  },
  { 
    id: 'colorful', 
    name: 'colorful',
    nativeName: 'Colorful Theme',
    icon: '🎨',
    description: 'Bright and colorful interface'
  },
  { 
    id: 'retro', 
    name: 'retro',
    nativeName: 'Retro Vintage',
    icon: '🕒',
    description: 'Vintage and retro interface'
  },
  { 
    id: 'pinkcrystal', 
    name: 'pinkcrystal',
    nativeName: 'Pink Crystal',
    icon: '💎',
    description: 'Elegant pink crystal theme'
  },
  { 
    id: 'yellowduck', 
    name: 'yellowduck',
    nativeName: 'Little Yellow Duck',
    icon: '🐥',
    description: 'Cheerful yellow theme'
  },
  { 
    id: 'greengrassland', 
    name: 'greengrassland',
    nativeName: 'Green Grassland',
    icon: '🌿',
    description: 'Fresh green nature theme'
  },
  { 
    id: 'silver', 
    name: 'silver',
    nativeName: 'Silver Metal',
    icon: '⚪',
    description: 'Sleek metallic silver style'
  }
];

// 預設主題
export const DEFAULT_THEME = 'light';

// 主題管理工具
export const ThemeManager = {
  // 獲取當前主題
  getCurrentTheme: () => {
    return localStorage.getItem('theme') || DEFAULT_THEME;
  },
  
  // 設定主題
  setTheme: (themeId: string) => {
    if (THEMES[themeId as keyof typeof THEMES]) {
      localStorage.setItem('theme', themeId);
      return true;
    }
    return false;
  },
  
  // 獲取主題資訊
  getThemeInfo: (themeId: string) => {
    return SUPPORTED_THEMES.find(theme => theme.id === themeId);
  },
  
  // 獲取主題配置
  getThemeConfig: (themeId: string) => {
    return THEMES[themeId as keyof typeof THEMES] || THEMES[DEFAULT_THEME];
  },
  
  // 獲取支援的主題列表
  getSupportedThemes: () => SUPPORTED_THEMES,
  
  // 獲取響應式配置
  getResponsiveConfig: (deviceType: string = 'desktop') => {
    return RESPONSIVE_CONFIG[deviceType as keyof typeof RESPONSIVE_CONFIG] || RESPONSIVE_CONFIG.desktop;
  },
  
  // 檢測設備類型
  detectDeviceType: () => {
    const width = window.innerWidth;
    if (width < 640) return 'mobile';
    if (width < 1024) return 'tablet';
    return 'desktop';
  },
  
  // 自動選擇響應式配置
  getAutoResponsiveConfig: () => {
    const deviceType = ThemeManager.detectDeviceType();
    return ThemeManager.getResponsiveConfig(deviceType);
  }
};

// 主題Hook函數
export const useTheme = (themeId = null) => {
  const currentTheme = themeId || ThemeManager.getCurrentTheme();
  const themeConfig = ThemeManager.getThemeConfig(currentTheme);
  
  return {
    theme: currentTheme,
    config: themeConfig,
    getClass: (type: string) => themeConfig.classes[type as keyof typeof themeConfig.classes] || '',
    getColor: (type: string) => themeConfig.colors[type as keyof typeof themeConfig.colors] || '',
    setTheme: ThemeManager.setTheme,
    getSupportedThemes: ThemeManager.getSupportedThemes
  };
};

// 響應式Hook函數
export const useResponsive = () => {
  const deviceType = ThemeManager.detectDeviceType();
  const config = ThemeManager.getResponsiveConfig(deviceType);
  
  return {
    deviceType,
    config,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    getBreakpoint: () => config.breakpoint
  };
}; 
